<template>
  <div>
    <div style="width:100%">
      <div class="form-title pt-0 float-left">基本信息</div>
      <a :href="pat_detail.pdfPath" target="_blank" :underline="false" class="form-title pt-0 float-right">
        <i class="fa fa-file-pdf-o mr-1" style="color:#e79178;"></i>查看
      </a>
    </div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td width="15%">申请号</td>
        <td width="35%">
          {{ pat_detail['patentNum'] }}
        </td>
        <td width="15%">申请日</td>
        <td width="35%">
          {{ pat_detail['applicationTime'] }}
        </td>
      </tr>
      <tr>
        <td width="15%">申请公布号</td>
        <td width="35%">
          {{ pat_detail['applicationPublishNum'] }}
        </td>
        <td width="15%">申请公布日</td>
        <td width="35%">
          {{ pat_detail['appubDate'] }}
        </td>
      </tr>
      <tr>
        <td width="15%">授权公告号</td>
        <td width="35%">
          {{ pat_detail['grantNumber'] }}
        </td>
        <td width="15%">授权公告日</td>
        <td width="35%">
          {{ pat_detail['grantDate'] }}
        </td>
      </tr>
      <tr>
        <td width="15%">分类号</td>
        <td width="85%" colspan="3">
          {{ pat_detail['allCatNum'] }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="form-title">申请人信息</div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td width="15%">申请（专利权）人</td>
        <td width="35%">
          {{ pat_detail['applicantName'] }}
        </td>
        <td width="15%">发明人</td>
        <td width="35%">
          {{ pat_detail['inventor'] }}
        </td>
      </tr>
      <tr>
        <td width="15%">地址</td>
        <td width="35%">
          {{ pat_detail['address'] }}
        </td>
        <td width="15%">邮编</td>
        <td width="35%">

        </td>
      </tr>
      </tbody>
    </table>

    <div class="form-title">代理人信息</div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td width="15%">代理机构</td>
        <td width="35%">
          {{ pat_detail['agency'] }}
        </td>
        <td width="15%">代理人</td>
        <td width="35%">
          {{ pat_detail['agent'] }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="form-title">摘要</div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td>
          <div v-html="pat_detail['abstracts']"></div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="form-title">法律状态</div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td width="10%">序号
        </td>
        <td width="20%">状态公告日
        </td>
        <td width="40%">状态
        </td>
        <td width="30%">状态信息
        </td>
      </tr>
      <tr v-for="(k,v) in pat_detail.stateOfLaw">
        <td>{{ v + 1 }}
        </td>
        <td>{{ k['date'] }}
        </td>
        <td>{{ k['detail'] }}
        </td>
        <td>{{ k['status'] }}
        </td>
      </tr>
      </tbody>
    </table>

    <div class="form-title">权利要求</div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td width="100%" style="background-color:#FFFFFF">
          <div v-html="pat_detail['claims']"></div>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="form-title">说明书</div>
    <table class="index_tableBox__ZadJW" width="100%">
      <tbody>
      <tr>
        <td width="100%" style="background-color:#FFFFFF">
          <div v-html="pat_detail['description']"></div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import util from "../api/util"
import api from "../api/rest";

export default {
  props: {
    pat_detail: {
      type: Object,
      default: {}
    }
  }
}
</script>


<style>
.patent-image {
  max-width: 600px;
}

.patent-full-image {
  max-width: 800px;
}

.form-title {
  font-size: 16px;
  font-weight: 700;
  padding-top: 20px;
  padding-bottom: 8px;
}

.index_tableBox__ZadJW td:nth-child(odd) {
  background-color: #f0f7fc;
}

.index_tableBox__ZadJW td {
  border: 1px solid #e4eef6;
  padding: 8px;
  vertical-align: middle;
}
</style>


// WEBPACK FOOTER //
// PatentDetail.vue?57237b96